import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function variableNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const variableName = control.value;
    const isValid = /^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(variableName);
    return isValid ? null : { invalidVariableName: true };
  };
}

@Directive({
  selector: '[appVariableName]',
  providers: [{ provide: NG_VALIDATORS, useExisting: VariableNameValidatorDirective, multi: true }]
})
export class VariableNameValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return variableNameValidator()(control);
  }
}